<div class="card text-left">
  <div class="card-body" style="background-color: #e4ecf2;">
    <h4 class="card-title" style="text-align: center;">Skills Training Provider (STP) Registration </h4>
    <h5 class="text-danger text-center" *ngIf="stpMainInfo?.isTempRejected">
        <b>***Your application needs correction.</b>
        <span *ngIf="stpMainInfo?.tempRejectReason">
          Reason: {{stpMainInfo?.tempRejectReason}}
        </span>
      </h5>
  </div>
</div>
<!-- try code -->
<!-- <div class="row justify-content-md-center">
  <div class="col col-lg-2">
    <button style="margin: 30px" nz-button nzShape="round" type="button" nzType="primary"
      (click)="onUserFullInformationRequest()">
      STP MAIN ID
    </button>
  </div>
</div> -->
<nz-tabset nzType="card" nzCentered [(nzSelectedIndex)]="selectedIndex">
  <nz-tab nzTitle="Basic Profile">
    <app-basic-profile></app-basic-profile>
  </nz-tab>

  <nz-tab nzTitle="Physical Infrastructure">
    <app-physical-infra-create></app-physical-infra-create>
  </nz-tab>

  <nz-tab nzTitle="Trainer">
    <app-occupation-specific-trainer></app-occupation-specific-trainer>
  </nz-tab>

  <nz-tab nzTitle="Management & Staff">
    <app-management-and-staffs></app-management-and-staffs>
  </nz-tab>

  <nz-tab nzTitle="Financial Details">
    <app-financial-details></app-financial-details>
  </nz-tab>
  <nz-tab nzTitle="Occupation Specific Tools">
    <app-occupation-specific-tools></app-occupation-specific-tools>
  </nz-tab>

  <nz-tab nzTitle="Furniture">
    <app-furniture-list></app-furniture-list>
  </nz-tab>
  <!-- <nz-tab nzTitle="Payments">
    <app-stp-payment></app-stp-payment>
  </nz-tab> -->
</nz-tabset>
